@if (!isNetworkAvailable()) {
  <div class="no-internet-toastr-wrap" [ngClass]="{ closed: !showOfflineMessage }">
    <div class="no-network-non-closable" (click)="toggleOfflineMessage()">
      <tds-icon name="wifi_inactive" size="18px"></tds-icon>
      <span>Working offline</span>
    </div>

    @if (showOfflineMessage) {
      <div class="no-network-closable">
        <div>
          <strong class="offline">OFFLINE</strong>
          <span>Your network is unavailable. Check your data or wifi connection.</span>
        </div>
        <span (click)="toggleOfflineMessage()">
          <tds-icon name="cross" size="18px"></tds-icon>
        </span>
      </div>
    }
  </div>
}
